import type {ColumnConfig} from 'schema/table/types';

export const norafUpdateDefaultColumns: ColumnConfig[] = [
  {
    name: 'nationalId',
    width: 100,
  },
  {
    name: 'name',
    width: 150,
  },
  {
    name: 'agentType',
    width: 50,
  },
  {
    name: 'lastUpdated',
    width: 100,
  },
];
